import {
  APPROVED_PRODUCTS_EXPORT_ALL,
  APPROVED_PRODUCTS_EXPORT_PUBLIC,
  APPROVED_PRODUCTS_GET_ALL,
  APPROVED_PRODUCT_GET_PROTOCOLVERSIONS_AND_LASTUPLOAD_DATE,
  APPROVED_PRODUCTS_GET_PUBLIC,
} from "_constants/ApprovedProductsAPI";
import { UrlFilterHelper } from "_helpers/UrlFilterHelper";
import axios from "axios";

export const approvedProductsService = {
  GetAll,
  GetPublic,
  GetProtocolVersionsAndLastUploadDate,
  prepareFilter,
  ExportAll,
  ExportPublic,
}

function prepareFilter() {
  return {
    components: [],
    protocolVersions: [],
    supportSCATestCases: "",
    supportDAFTestCases: "",
    supportBMETestCases: "",
    publishedProducts: "",
    unpublishedProducts: ""

  }
}

function GetProtocolVersionsAndLastUploadDate(isAdmin) {
  return axios.get(APPROVED_PRODUCT_GET_PROTOCOLVERSIONS_AND_LASTUPLOAD_DATE + "?isAdmin=" + isAdmin);
}

function GetAll(skipCount, sorting, dsc, filter, search) {
  var url = UrlFilterHelper.GetFilterdUrl(APPROVED_PRODUCTS_GET_ALL, skipCount, encodeURIComponent(search), sorting, dsc)
  url = prepareFilterQuery(url, filter)
  return axios.get(url);
}

function prepareFilterQuery(url, filter, isPublic = false) {
  for (let component of filter.components) {
    url += "&components=" + encodeURIComponent(component)
  }

  for (let version of filter.protocolVersions) {
    url += "&protocolVersions=" + encodeURIComponent(version)
  }

  url += "&supportSCATestCases=" + filter.supportSCATestCases
  url += "&supportDAFTestCases=" + filter.supportDAFTestCases
  url += "&supportBMETestCases=" + filter.supportBMETestCases

  if (!isPublic) {
    url += "&publishedProducts=" + filter.publishedProducts
    url += "&unpublishedProducts=" + filter.unpublishedProducts
  }


  return url
}

function GetPublic(skipCount, sorting, dsc, filter, search) {
  var url = UrlFilterHelper.GetFilterdUrl(APPROVED_PRODUCTS_GET_PUBLIC, skipCount, encodeURIComponent(search), sorting, dsc)
  url = prepareFilterQuery(url, filter, true)
  return axios.get(url);
}

function ExportAll(skipCount, sorting, dsc, filter, search) {
  var url = UrlFilterHelper.GetFilterdUrl(APPROVED_PRODUCTS_EXPORT_ALL, skipCount, encodeURIComponent(search), sorting, dsc)
  url = prepareFilterQuery(url, filter)

  return axios.get(url, {
    responseType: "blob",
  });
}

function ExportPublic(skipCount, sorting, dsc, filter, search) {
  var url = UrlFilterHelper.GetFilterdUrl(APPROVED_PRODUCTS_EXPORT_PUBLIC, skipCount, encodeURIComponent(search), sorting, dsc)
  url = prepareFilterQuery(url, filter, true)

  return axios.get(url, {
    responseType: "blob",
  });
}
